import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]


import { B2CMyPersonalOfferOverviewTileModel } from '@/types/B2CcontentServerContract';
import BlockMaxWidthHandler from '@/shared/content/blocks/helpers/BlockMaxWidthHandler.vue';
import Offers from '@/b2c/offers/ui/Offers.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'B2CMyPersonalOfferOverviewTile',
  props: {
    content: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BlockMaxWidthHandler, null, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "mb-40",
        innerHTML: __props.content.heading
      }, null, 8, _hoisted_1),
      _createVNode(Offers, {
        "details-url": __props.content.detailUrl
      }, null, 8, ["details-url"])
    ]),
    _: 1
  }))
}
}

})